<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <el-backtop></el-backtop>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  components: {},
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: SimSun;
}
body, html {
    font-family:SimSun;
}
</style>



// WEBPACK FOOTER //
// src/App.vue